import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../../axiosClient";

const BACKEND_URL = process.env.REACT_APP_LARAVEL_API;

export const getDownloadables = createAsyncThunk(
    "download/getDownloadables",
    async (token, thunkAPI) => {
      try {
        const res = await axios.get(
          `${BACKEND_URL}/downloadables`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        return res.data.data;
      } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
      }
    }
)

const workerDownloadSlice = createSlice({
    name: "workerDownload",
    initialState: {
      downloadData: [],
      loading: false,
      error: null,
      message: "",
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDownloadables.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getDownloadables.fulfilled, (state, action) => {
                state.loading = false;
                state.downloadData = action.payload;
            })
            .addCase(getDownloadables.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    },
});

export default workerDownloadSlice.reducer;
